import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Securing Inventory App with App ID`}</p>
    </PageDescription>
    <p>{`To secure the application we are using the capabilities available within the IBMCloud platform that use
a simple annotation on the ingress to enable integration with AppId. The `}<Globals name="templates" mdxType="Globals" />{` have already been
set up to use this feature and all that is required is update the configuration within the `}<inlineCode parentName="p">{`values.yaml`}</inlineCode>{`
file of the helm chart.`}</p>
    <h3>{`Inventory Management UI`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Find the app id binding secret by running the following command from a terminal where the kubernetes context has been set up (i.e. `}<inlineCode parentName="p">{`oc login`}</inlineCode>{` has been done)`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`kubectl get -n dev secrets | grep -E "binding.*appid"
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Update the `}<inlineCode parentName="p">{`values.yaml`}</inlineCode>{` file in the Inventory Management UI chart to set `}<inlineCode parentName="p">{`ingress.appId.enabled=true`}</inlineCode>{` and to
set the value for the AppId binding secret from the previous step`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-yaml",
            "metastring": "path=/chart/template-node-react/values.yaml",
            "path": "/chart/template-node-react/values.yaml"
          }}>{`...

ingress:
  enabled: true
  appid:
    enabled: true
    # web or app - https://cloud.ibm.com/docs/services/appid?topic=appid-kube-auth
    requestType: web
    binding:
      name: "{binding secret}"
      namespace: dev
    ...
`}</code></pre>
      </li>
    </ul>
    <h3>{`AppId redirect url config`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Get the ingress for the UI component by running `}<inlineCode parentName="p">{`igc ingress -n dev-{initials}`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Open the IBM Cloud resource list - `}<inlineCode parentName="p">{`https://cloud.ibm.com/resources`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Open the AppId instance to the `}<inlineCode parentName="p">{`Manage Authentication`}</inlineCode>{` -> `}<inlineCode parentName="p">{`Authentication Settings`}</inlineCode>{` view`}</p>
        <p parentName="li">{`  `}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "32.63888888888889%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAAA6UlEQVQoz42SYW7DIAyFuf/pdoBJmzZl3dqkEGJsIIE3lyTbmj8r0qdnkHkYg4l5Qa0VNiT01iOEAD8RRKStl1KaPopxE6NUgGNSo4DAosSmHDMkLZvxYxgiwqKB84zLMOJy9RjchEGrJU4IMit50/8xgbkZ9pbw9nHGefB4PTm8dBZuii2JeE2mjX0zHVXzDOvV5qViClGrJHiSZrSaJfDGMV7n+U5jUsNaixoWjNrL9+6E7vML1o24Oq8HBE3WXkr8o3ss+nC/6xIjekcw0JHn0vpE+hi3Sn/g/fR7+BDfep31tzw99/gG+e4gxo2xhqIAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "AppId authentication settings",
              "title": "AppId authentication settings",
              "src": "/ibm-cloudnative-journey/static/ae4bd4e1a182887c1a8672620c4ff566/3cbba/appid-authentication-settings.png",
              "srcSet": ["/ibm-cloudnative-journey/static/ae4bd4e1a182887c1a8672620c4ff566/7fc1e/appid-authentication-settings.png 288w", "/ibm-cloudnative-journey/static/ae4bd4e1a182887c1a8672620c4ff566/a5df1/appid-authentication-settings.png 576w", "/ibm-cloudnative-journey/static/ae4bd4e1a182887c1a8672620c4ff566/3cbba/appid-authentication-settings.png 1152w", "/ibm-cloudnative-journey/static/ae4bd4e1a182887c1a8672620c4ff566/0b124/appid-authentication-settings.png 1728w", "/ibm-cloudnative-journey/static/ae4bd4e1a182887c1a8672620c4ff566/4ea69/appid-authentication-settings.png 2304w", "/ibm-cloudnative-journey/static/ae4bd4e1a182887c1a8672620c4ff566/4640e/appid-authentication-settings.png 3072w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Add the redirect url for the application to the web redirect URLs. The redirect url will have
the following form:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`\`{ingress url}/appid_callback\`

e.g. \`https://inventory-manangement-ui-dev.sms-test-oc-cluster.us-east.containers.appdomain.cloud/appid_callback\`
`}</code></pre>
      </li>
    </ul>
    <h3>{`Add users to AppId`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Open the AppId instance to `}<inlineCode parentName="p">{`Cloud Directory`}</inlineCode>{` -> `}<inlineCode parentName="p">{`Users`}</inlineCode></p>
        <p parentName="li">{`  `}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "40.97222222222222%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABLUlEQVQoz41RWU7DUAzM/W/CJeAGnACEEIUWlTRv35Nh7AjUDyrxMfFzxh5v02IsQkzYtg2zz1isR0wJPkSMMTDWDSTBz78wOe+RS8HKpJAKXEiIubBIVj/kjj5Wim9/QrhrTCFGCFpf8XXxOJ4XnM4GZ75DauQqHOFvQGNSRyqdjXVMi3Eq2Fnt/XPG8+sHXt6OOJxmWK7AuLRD37tvdTVR8SN6sQVnkzFZn6hckWsnUSF+pK1tReK42h0TfNwhybtftcBCuJBx/3jA3cOTdGiZmHVkIRyPMS9W9yc7MS6g1AbnoyKXxtUYCmZ05hQ2YnjI2oY2Nc2L0aOIoI9FA0XE8zgS1PpQTt7qq+W+WES4lKseUP4JP1lH9VrVkXEix4x5qN0Xfgv9117HfgPDfmzKObgiOQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "AppId cloud directory users",
              "title": "AppId cloud directory users",
              "src": "/ibm-cloudnative-journey/static/19d8a02b9ace5eb0cb8a36df89ccc7ad/3cbba/appid-cloud-directory-users.png",
              "srcSet": ["/ibm-cloudnative-journey/static/19d8a02b9ace5eb0cb8a36df89ccc7ad/7fc1e/appid-cloud-directory-users.png 288w", "/ibm-cloudnative-journey/static/19d8a02b9ace5eb0cb8a36df89ccc7ad/a5df1/appid-cloud-directory-users.png 576w", "/ibm-cloudnative-journey/static/19d8a02b9ace5eb0cb8a36df89ccc7ad/3cbba/appid-cloud-directory-users.png 1152w", "/ibm-cloudnative-journey/static/19d8a02b9ace5eb0cb8a36df89ccc7ad/0b124/appid-cloud-directory-users.png 1728w", "/ibm-cloudnative-journey/static/19d8a02b9ace5eb0cb8a36df89ccc7ad/4ea69/appid-cloud-directory-users.png 2304w", "/ibm-cloudnative-journey/static/19d8a02b9ace5eb0cb8a36df89ccc7ad/ed928/appid-cloud-directory-users.png 3094w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Add yourself as a user with an email address, name, and password`}</p>
      </li>
    </ul>
    <h3>{`Access the UI`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Open a browser to the UI ingress`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You should be met with the AppId login screen. (This screen can be customized from the AppId service console but for now we are showing the default screen.)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Provide the email address and password you configured in the previous steps. You should be granted access to the UI.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      